export const RecoverySteps = {
  "es-CL": [
    "Agregar recuperaciones",
    "Ingresar datos de envio",
    "Confirmar solicitud",
  ],
  "en-US": ["Add recoveries", "Set delivery info", "Confirm request"],
};
